var live_event_gallery = ( function( $ ) {

	var $gallery,
		$gallery_item_link;

	var _init = function() {
		$gallery           = $( '#course-gallery' );
		$gallery_item_link = $gallery.find( '.gallery-item-link' );

		_setup_carousel();
		_setup_popup();
	};

	var _setup_carousel = function() {
		$gallery.find( '.carousel-inner' ).owlCarousel({
			dots : false,
			items: 1,
			responsive:{
				0 : {
					items : 1
				},
				481 : {
					items : 3
				}
			},
			nav : true,
			navText: ['<', '>']
		});
	};

	var _setup_popup = function() {
		$gallery_item_link.magnificPopup({
			type: 'image',
			gallery: {
				enabled : true
			}
		});
	};

	if ( $( '#course-gallery' ).length ) {
		$( document ).ready( _init );
	}

} )( jQuery );

module.exports = live_event_gallery;